export default __webpack_public_path__ + "static/media/04.ad6ae2ab.jpg";